import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import colors from "common/styles/colors";
import { ComponentWithChildren } from "../../../../../common/types";

const useStyles = makeStyles({
  h2: {
    fontWeight: 600,
    fontSize: "22px",
    color: colors.darkGrey1,
    marginTop: "37px",
    marginBottom: "10px",
    lineHeight: "32px",
    ["@media (max-width:600px)"]: {
      fontSize: "20px",
      lineHeight: "28px"
    }
  }
});

export const HeadingSecondary: ComponentWithChildren = ({ children }) => {
  const styles = useStyles();

  return (
    <Typography className={styles.h2} variant={"h2"}>
      {children}
    </Typography>
  );
};
